__turbopack_context__.v({
  "addPill": "TeamInvestorDetails-module-scss-module__IoTT_W__addPill",
  "content": "TeamInvestorDetails-module-scss-module__IoTT_W__content",
});
